import { useTranslation } from "react-i18next";
import Lottie from "react-lottie";
import animationData from "../../FInal.json";
import arrowIcon from "../../assets/arrow.svg";
import { Button } from "reactstrap";


const Hero = () => {
  const { t } = useTranslation();
  const options = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="mx-auto max-w-1200">
      <div className="flex lg:items-center max-sm:px-4 max-xl:px-6 lg:py-6 max-lg:flex-col max-lg:gap-[61px]">
        <div className="flex flex-col gap-4 lg:w-1/2">
          <div className="flex md:flex-col flex-wrap md:gap-2 gap-2">
            <h2 className="block w-full text-darkGray font-extrabold text-4xl lg:text-[40px] font-sans sm:text-[40px] leading-[48px] pb-1">
              {t("Automate Processes")}
            </h2>
            <div className="flex gap-3 items-center">
              <div className="d-flex flex-row text-darkGray font-extrabold font-sans  text-4xl sm:text-[40px] sm:leading-[48px] h-[48px]">
                <span className="relative top-[-14px] text-darkGray ">
                  {" "}
                  {t("for")}
                </span>
                <span
                  style={{
                    height: "48px",
                    overflow: "hidden",
                    display: "inline-block",
                  }}
                >
                  <span
                    id="department"
                    className="text-darkPurple text-4xl sm:text-[40px]"
                    style={{
                      lineHeight: "48px",
                      fontWeight: 800,
                      marginLeft: "13px",
                    }}
                  >
                    Corporate
                    <br />
                    License
                    <br />
                    Compliance
                    <br />
                    Corporate
                  </span>
                </span>
              </div>
            </div>
            <div className="block w-full text-darkGray font-extrabold font-sans  text-4xl sm:text-[40px] sm:leading-[48px]">
              {t("management")}
            </div>
          </div>
          <div className="max-sm:hidden text-darkGray/70 text-lg">
            <span className="font-bold">RegTechFlow </span>
            <span>
              is the all-in-one tool for professionals and businesses looking to
              scale compliance and corporate governance.
            </span>
          </div>
          <Button ButtonText='Request a Demo Today' icon={arrowIcon} path="/book-demo" disable={true}/>
        </div>

        <div className="bg-background lg:p-4 flex justify-center items-center mx-auto max-w-[358px] sm:max-w-[720px] lg:w-1/2">
          <Lottie options={options} style={{ borderRadius: "16px" }} />
        </div>
      </div>
    </div>
  );
};

export { Hero };
